<template>
  <v-row>
    <v-col md="10" offset-md="1" xl="8" offset-xl="2">
      <v-alert v-if="message" border="left" type="success" elevation="2">
        {{ message }}
      </v-alert>
      <BaseBlock v-if="candidature" :title="titreCandidature">
        <v-form v-model="valid" ref="form" width="100%">
          <v-alert
            v-if="error.messages"
            border="left"
            type="error"
            elevation="2"
          >
            <template v-for="(errorMessage, index) in error.messages">
              <span :key="index">
                {{ errorMessage }}
                <br />
              </span>
            </template>
          </v-alert>
          <div v-if="!(idCandidature > 0)">
            <v-row v-if="typesDiplomes.length > 0">
              <v-col cols="12" md="4">
                <v-select
                  v-model="idTypeDiplome"
                  label="Type de diplôme *"
                  :items="typesDiplomes"
                  item-value="id"
                  item-text="libelle"
                  :rules="typeDiplomeRules"
                  @change="loadFormations(idTypeDiplome)"
                >
                </v-select>
              </v-col>
              <v-col v-if="idTypeDiplome" cols="12" md="8">
                <v-select
                  v-model="candidature.idFormation"
                  label="Formation *"
                  :items="formations"
                  item-value="id"
                  item-text="libelle"
                  no-data-text="Aucune formation disponible"
                  :rules="formationRules"
                  @change="loadFormation(candidature.idFormation)"
                >
                </v-select>
              </v-col>
            </v-row>
          </div>
          <div v-else>
            <v-row v-if="!isModeEdition">
              <v-col cols="12" md="7">
                <span class="font-weight-light">État de la demande: </span
                ><span class="elevation-5">{{
                  getLibelleEtat(candidature.etatDemande.id)
                }}</span>
              </v-col>
              <v-col v-if="candidature.dateDepot" cols="12" md="5">
                <span class="font-weight-light">Date de dépôt: </span
                ><span class="elevation-5"> {{ candidature.dateDepot }} </span>
              </v-col>
            </v-row>
          </div>
          <div v-if="formation.id">
            <v-row>
              <v-col
                v-if="formation.piecesAFournir.length > 0"
                cols="12"
                md="8"
              >
                <DepotPieces
                  :idFormation="formation.id"
                  :modeEdition="isModeEdition"
                  :piecesAFournir="formation.piecesAFournir"
                  :key="keyListePiecesAFournir"
                  @depot="forceRerenderListePiecesEtudiant"
                  @majPiecesEtu="majPiecesEtu"
                >
                </DepotPieces>
              </v-col>
              <v-col cols="12" md="4">
                <v-row v-if="formation.piecesAFournir.length > 0">
                  <v-col cols="12">
                    <ListePiecesEtudiant
                      :idEtudiant="candidature.idEtudiant"
                      :idFormation="formation.id"
                      :key="keyListePiecesEtudiant"
                    >
                    </ListePiecesEtudiant>
                  </v-col>
                </v-row>
                <div v-if="isModeEdition">
                  <v-row>
                    <v-col cols="12">
                      <div class="text-center">
                        <v-btn
                          class="mx-2"
                          :disabled="!valid"
                          color="primary"
                          small
                          @click="enregistrer"
                          :loading="loadingEnregistrer"
                        >
                          <v-icon left>save</v-icon>Enregistrer sans valider
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <div class="text-center">
                        <ButtonConfirmation
                          :inactif="!valid || !validPieces"
                          icone="mdi-check-bold"
                          libelle="Valider la demande"
                          title="Mon dossier est complet, je valide ma demande"
                          :loading="loadingValider"
                          @ok="valider"
                        ></ButtonConfirmation>
                        <v-tooltip v-if="!valid || !validPieces" left>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              large
                              color="blue darken-2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              mdi-help-circle
                            </v-icon>
                          </template>
                          <span
                            >Avant de valider, téléversez les pièces requises
                            pour l'examen de votre candidature</span
                          >
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <v-row>
                  <v-col cols="12">
                    <div class="text-center">
                      <router-link
                        :to="{
                          name: 'mes-candidatures'
                        }"
                      >
                        <v-btn class="mx-2" color="primary">Retour</v-btn>
                      </router-link>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-expansion-panels v-if="candidature.id && candidature.id > 0">
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <span class="primary--text">
                    Voir l'historique de la candidature
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <HistoriqueCandidature
                    :idCandidature="candidature.id"
                  ></HistoriqueCandidature>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-form>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import ListePiecesEtudiant from "@/components/ListePiecesEtudiant";
import ButtonConfirmation from "@/components/ButtonConfirmation";
import DepotPieces from "@/components/DepotPieces";
import ApiEtudiantRepository from "@/repositories/ApiEtudiantRepository";
import moment from "moment";
import HistoriqueCandidature from "@/components//HistoriqueCandidature.vue";

export default {
  name: "FormCandidature",
  components: {
    BaseBlock,
    ListePiecesEtudiant,
    ButtonConfirmation,
    DepotPieces,
    HistoriqueCandidature
  },
  mixins: [EtatDemande],
  extends: BaseForm,
  props: ["idCandidature"],
  data() {
    return {
      message: null,
      loadingEnregistrer: false,
      loadingValider: false,
      candidature: {
        id: this.idCandidature,
        idEtudiant: null,
        idFormation: "",
        dateDepot: null,
        etatDemande: { id: 1 }
      },
      idTypeDiplome: "",
      typesDiplomes: [],
      typeDiplomeRules: [
        v => !!v || "Veuillez sélectionner le type de diplôme"
      ],
      formation: {},
      formations: [],
      formationRules: [v => !!v || "Veuillez sélectionner la formation"],
      validPieces: false,
      keyListePiecesEtudiant: 0,
      keyListePiecesAFournir: 0,
      // 15MB
      maxSizeUpload: 15728640,
      typesPiecesEtu: [],
      reorientation: {}
    };
  },
  computed: {
    titreCandidature() {
      return this.idCandidature > 0
        ? this.formation.libelle
          ? "Candidature à la formation '" + this.formation.libelle + "'"
          : ""
        : "Nouvelle candidature à une formation";
    },
    isRectifCampagneAuthorized() {
      return this.aujourdhui <=
        moment(this.reorientation.dateFin, "DD/MM/YYYY").add(
          this.reorientation.nbJoursRectif,
          "days"
        )
        ? true
        : false;
    },
    isModeEdition() {
      return (
        this.idCandidature == 0 ||
        (this.isFormationOuverte(this.candidature) &&
          this.isCasModif(this.candidature)) ||
        this.isRectifCandidatureAuthorized(this.candidature)
      );
    },
    aujourdhui() {
      return moment(moment().format("DD/MM/YYYY"), "DD/MM/YYYY");
    }
  },
  async created() {
    await this.isReorientationOuverte();
    if (this.idCandidature > 0) {
      await this.getCandidature(this.idCandidature);
      if (this.candidature.idFormation > 0) {
        await this.getFormation(this.candidature.idFormation);
      }
    } else {
      await this.getTypesDiplomes();
    }
  },
  methods: {
    async loadFormations(idTypeDiplome) {
      this.formation.id = 0;
      await this.getFormationsParTypeDiplome(idTypeDiplome);
    },
    async loadFormation(idFormation) {
      this.validPieces = false;
      await this.getFormation(idFormation);
      await this.forceRerenderListePiecesAFournir();
      this.forceRerenderListePiecesEtudiant();
      //this.verifPieces(this.typesPiecesEtu);
    },
    async getTypesDiplomes() {
      try {
        const typesDiplomes = await ApiFormationRepository.getTypesDiplomes();
        this.typesDiplomes = typesDiplomes;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async getFormationsParTypeDiplome(idTypeDiplome) {
      try {
        const formations = await ApiFormationRepository.getFormationsParTypeDiplome(
          idTypeDiplome
        );
        this.formations = formations;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async getCandidature(idCandidature) {
      try {
        const candidature = await ApiCandidatureRepository.getCandidatureEtudiant(
          idCandidature
        );
        this.candidature = candidature;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async getFormation(idFormation) {
      try {
        const formation = await ApiFormationRepository.getFormation(
          idFormation
        );
        this.formation = formation;
      } catch (error) {
        this.populateErrors(error);
      }
    },
    async enregistrer() {
      await this.enregistrerSansValider();
      this.$router.push({ name: "mes-candidatures" });
    },
    async valider() {
      await this.enregistrerEtValider();
      this.$router.push({ name: "mes-candidatures" });
    },
    async enregistrerSansValider() {
      this.loadingEnregistrer = true;
      try {
        if (this.idCandidature > 0) {
          await ApiCandidatureRepository.updateCandidatureEtudiant(
            this.idCandidature,
            this.candidature
          );
          this.$toast.success("Candidature modifiée");
        } else {
          await ApiCandidatureRepository.addCandidatureEtudiant(
            this.candidature
          );
          this.$toast.success("Candidature ajoutée");
        }
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loadingEnregistrer = false;
      }
    },
    async enregistrerEtValider() {
      this.loadingValider = true;
      try {
        if (this.idCandidature > 0) {
          await ApiCandidatureRepository.updateAndValidateCandidatureEtudiant(
            this.idCandidature,
            this.candidature
          );
        } else {
          await ApiCandidatureRepository.addAndValidateCandidatureEtudiant(
            this.candidature
          );
        }
        if (this.candidature.etatDemande.id === this.ETAT.BROUILLON.code) {
          this.$toast.success(
            "Votre candidature est désormais en attente de validation par le SUAIO"
          );
        }
        if (this.candidature.etatDemande.id === this.ETAT.RECTIFICATION.code) {
          this.$toast.success(
            "Votre candidature est désormais en attente de traitement pédagogique"
          );
        }
      } catch (error) {
        this.populateErrors(error);
      } finally {
        this.loadingValider = false;
      }
    },
    forceRerenderListePiecesEtudiant() {
      this.keyListePiecesEtudiant += 1;
    },
    forceRerenderListePiecesAFournir() {
      this.keyListePiecesAFournir += 1;
    },
    piecesOK() {
      this.validPieces = true;
    },
    getLibelleEtat(code) {
      const listeEtats = Object.values(this.ETAT);
      const etat = listeEtats.filter(etat => etat.code == code);
      if (etat) {
        return etat[0].libelle;
      }
      return "";
    },
    verifPieces(typesPiecesEtu) {
      let validPieces = true;
      this.formation.piecesAFournir.forEach(pieceAFournir => {
        if (pieceAFournir.obligatoire) {
          if (typesPiecesEtu.indexOf(pieceAFournir.id) < 0) {
            validPieces = false;
          }
        }
      });
      this.validPieces = validPieces;
    },
    majPiecesEtu(typesPiecesEtu) {
      this.typesPiecesEtu = typesPiecesEtu;
      this.verifPieces(typesPiecesEtu);
    },
    async isReorientationOuverte() {
      try {
        const reo = await ApiEtudiantRepository.isReorientationOuverte();
        this.reorientation = reo;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    isCasModif(candidature) {
      return candidature.etatDemande.id === this.ETAT.BROUILLON.code ||
        candidature.etatDemande.id === this.ETAT.RECTIFICATION.code
        ? true
        : false;
    },
    isCasRectif(candidature) {
      return this.isCasModif(candidature) &&
        candidature.dateDepot &&
        candidature.dateDepot.length > 0
        ? true
        : false;
    },
    isFormationOuverte(candidature) {
      return candidature.dateFermetureFormation
        ? this.aujourdhui <=
            moment(candidature.dateFermetureFormation, "DD/MM/YYYY")
        : this.aujourdhui <= moment(this.reorientation.dateFin, "DD/MM/YYYY");
    },
    isRectifCandidatureAuthorized(candidature) {
      if (!this.isCasRectif(candidature)) {
        return false;
      }
      if (!candidature.dateFermetureFormation) {
        // pas de date de fin spécifique à la formation => on se base sur date fin réo
        return this.isRectifCampagneAuthorized;
      }
      // date fin spécifique
      let dateFermetureFormation = moment(
        candidature.dateFermetureFormation,
        "DD/MM/YYYY"
      );
      if (
        this.aujourdhui <=
        dateFermetureFormation.add(this.reorientation.nbJoursRectif, "days")
      ) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>
